"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1439],{

/***/ 725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "setAPI": function() { return /* binding */ setAPI; }
/* harmony export */ });
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4663);
/* harmony import */ var _common_config_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3807);
/* harmony import */ var _common_event_emitter_contextual_ee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5891);
/* harmony import */ var _common_event_emitter_handle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5300);
/* harmony import */ var _common_event_emitter_register_handler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5992);
/* harmony import */ var _common_util_invoke__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2016);
/* harmony import */ var _features_metrics_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3705);
/* harmony import */ var _common_constants_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9152);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */








function setAPI(agentIdentifier) {
  var instanceEE = _common_event_emitter_contextual_ee__WEBPACK_IMPORTED_MODULE_2__.ee.get(agentIdentifier);
  var api = {
    finished: (0,_common_util_invoke__WEBPACK_IMPORTED_MODULE_7__/* .single */ .Z)(finished),
    setErrorHandler,
    addToTrace,
    addRelease
  };

  // Hook all of the api functions up to the queues/stubs created in loader/api.js
  Object.entries(api).forEach(([fnName, fnCall]) => (0,_common_event_emitter_register_handler__WEBPACK_IMPORTED_MODULE_4__/* .registerHandler */ .X)('api-' + fnName, fnCall, 'api', instanceEE));

  // All API functions get passed the time they were called as their
  // first parameter. These functions can be called asynchronously.

  function finished(t, providedTime) {
    var time = providedTime ? providedTime - _common_constants_runtime__WEBPACK_IMPORTED_MODULE_6__/* .originTime */ .sK : t;
    (0,_common_event_emitter_handle__WEBPACK_IMPORTED_MODULE_3__/* .handle */ .p)(_features_metrics_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOM_METRIC_CHANNEL */ .vz, ['finished', {
      time
    }], undefined, _features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.metrics */ .DT.metrics, instanceEE);
    addToTrace(t, {
      name: 'finished',
      start: time + _common_constants_runtime__WEBPACK_IMPORTED_MODULE_6__/* .originTime */ .sK,
      origin: 'nr'
    });
    (0,_common_event_emitter_handle__WEBPACK_IMPORTED_MODULE_3__/* .handle */ .p)('api-addPageAction', [time, 'finished'], undefined, _features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.genericEvents */ .DT.genericEvents, instanceEE);
  }
  function addToTrace(t, evt) {
    if (!(evt && typeof evt === 'object' && evt.name && evt.start)) return;
    var report = {
      n: evt.name,
      s: evt.start - _common_constants_runtime__WEBPACK_IMPORTED_MODULE_6__/* .originTime */ .sK,
      e: (evt.end || evt.start) - _common_constants_runtime__WEBPACK_IMPORTED_MODULE_6__/* .originTime */ .sK,
      o: evt.origin || '',
      t: 'api'
    };
    (0,_common_event_emitter_handle__WEBPACK_IMPORTED_MODULE_3__/* .handle */ .p)('bstApi', [report], undefined, _features_features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_NAMES.sessionTrace */ .DT.sessionTrace, instanceEE);
  }
  function setErrorHandler(t, handler) {
    (0,_common_config_runtime__WEBPACK_IMPORTED_MODULE_1__/* .getRuntime */ .O)(agentIdentifier).onerror = handler;
  }
  var releaseCount = 0;
  function addRelease(t, name, id) {
    if (++releaseCount > 10) return;
    (0,_common_config_runtime__WEBPACK_IMPORTED_MODULE_1__/* .getRuntime */ .O)(agentIdentifier).releaseIds[name.slice(-200)] = ('' + id).slice(-200);
  }
}

/***/ })

}]);